/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import type { TabBarProps } from "$src/core/components/organisms/TabBar/types";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => React.FC<TabBarProps>>({
  web: () => require("./TabBar.web").default,
  androidTV: () => require("./TabBar.androidtv").default,
  default: () => () => null,
})();
